import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import InstitutionsList from '../containers/InstitutionsList';
import InstitutionDetail from '../containers/InstitutionDetail';
import InstitutionCreateForm from '../containers/InstitutionCreateForm';
import InstitutionUpdateForm from '../containers/InstitutionUpdateForm';
import NotFound from './common/NotFound';


export default class Routes extends Component {

  render() {
    return (
      <div>
        <Switch>
          <Route path="/institutions/edit" component={NotFound} />
          <Route path="/institutions/list" component={InstitutionsList} />
          <Route path="/institutions/detail" component={InstitutionDetail} />
          <Route path="/institutions/password" component={NotFound} />
          <Route path="/institutions/create" component={InstitutionCreateForm} />
          <Route path="/institutions/update" component={InstitutionUpdateForm} />
        </Switch>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Routes.js